import React from 'react';
import EntityMultiSelect, { selectedEntityIds, entityLabel } from '../../../../shared/components/EntityMultiSelect';
import { PartyField } from '../../../../shared/components/PartyFormFields';
import { AccountingAmountField, AccountingSelectField } from '../shared/AccountingFormFields';
import { expenseFormSchema } from '../../config/accountingForm.schemas';
import { FormFooterAction } from '../../../../shared/components/FormActionsContext';
import ClientCustomFieldsSection from '../../../clients/components/ClientCustomFieldsSection';
import { archiveAccountingCustomField, createAccountingCustomField, listAccountingCustomFields } from '../../services/accounting-custom-fields.service';
import { CreateFormCancelButton, CreateFormSubmitButton } from '../../../../shared/components/CreateFormDialog';

const EXPENSE_CUSTOM_FIELDS_API = { list: listAccountingCustomFields, create: createAccountingCustomField, archive: archiveAccountingCustomField };

export default function ExpenseForm({
  form, staff = [], staffUnavailable = false, suppliers = [], supplierUnavailable = false,
  onFieldChange, onCancel, onSubmit, submitLabel = 'Crea Spesa', isSubmitting = false,
  renderActions = true, enableCustomFields = false, requireDescription = false,
}) {
  const activeSuppliers = suppliers.filter(supplier => supplier.status !== 'INACTIVE');
  const recurring = form.recurring && form.recurring !== 'una_tantum';
  function changeRecipient(value) {
    onFieldChange('recipientType', value);
    if (value !== 'STAFF') { onFieldChange('staffId', ''); onFieldChange('staffIds', []); }
    if (value !== 'SUPPLIER') { onFieldChange('supplierId', ''); onFieldChange('supplierIds', []); onFieldChange('supplierName', ''); }
  }
  return <form id="expense-form" className="party-form create-form-dialog__form" onSubmit={event => { event.preventDefault(); onSubmit?.(); }}>
    <PartyField id="description" label="Titolo" required value={form.description} maxLength={255}
      onChange={value => onFieldChange('description', value)} placeholder="Inserisci titolo..." disabled={isSubmitting} />
    <PartyField id="expense-notes" label="Descrizione" multiline rows={3} required={requireDescription}
      value={form.notes} onChange={value => onFieldChange('notes', value)}
      placeholder="Inserisci una descrizione dettagliata per la spesa..." disabled={isSubmitting} />
    <fieldset className="party-form__segments" disabled={isSubmitting}>
      <legend>Destinatario</legend>
      <div className="party-form__segment-options">
        {['STAFF', 'SUPPLIER', 'OTHER'].map(value => <label key={value}>
          <input type="radio" name="recipientType" value={value} checked={(form.recipientType || 'OTHER') === value}
            onChange={() => changeRecipient(value)} />
          <span>{expenseFormSchema.field('recipientType').options.find(option => option.value === value).label}</span>
        </label>)}
      </div>
    </fieldset>
    {form.recipientType === 'STAFF' && <div className="party-form__field">
      <label htmlFor="staffId">Personale *</label>
      <EntityMultiSelect id="staffId" label="Membri del team" options={staff} required disabled={isSubmitting}
        value={selectedEntityIds(form, 'staff')} onChange={ids => { onFieldChange('staffIds', ids); onFieldChange('staffId', ids[0] || ''); }} />
      {staffUnavailable && <p role="alert" className="wt-inline-error">Catalogo staff non disponibile dal backend.</p>}
    </div>}
    {form.recipientType === 'SUPPLIER' && <div className="party-form__field">
      <label htmlFor="supplierId">Fornitore *</label>
      <EntityMultiSelect id="supplierId" label="Fornitori" options={activeSuppliers} required disabled={isSubmitting}
        value={selectedEntityIds(form, 'supplier')} onChange={ids => {
          onFieldChange('supplierIds', ids); onFieldChange('supplierId', ids[0] || '');
          onFieldChange('supplierName', ids.map(id => entityLabel(activeSuppliers.find(item => String(item.id) === id))).join(', '));
        }} />
      {supplierUnavailable && <p role="alert" className="wt-inline-error">Catalogo fornitori non disponibile dal backend.</p>}
      {!form.supplierId && form.supplierName && <p className="party-form__help">Fornitore legacy: {form.supplierName}</p>}
    </div>}
    <div className="party-form__row">
      <AccountingSelectField id="type" label="Tipo di Spesa" value={form.type} required disabled={isSubmitting}
        options={expenseFormSchema.field('type').options} onChange={value => onFieldChange('type', value)} />
      <AccountingSelectField id="recurring" label="Ricorrenza" value={form.recurring} disabled={isSubmitting}
        options={expenseFormSchema.field('recurring').options.map(option => option.value === 'una_tantum' ? { ...option, label: 'Nessuna' } : option)}
        onChange={value => onFieldChange('recurring', value)} />
    </div>
    <div className="party-form__row">
      <PartyField id="dueDate" label="Data di Scadenza" type="date" required value={form.dueDate}
        onChange={value => onFieldChange('dueDate', value)} disabled={isSubmitting} />
      <AccountingAmountField id="amount" value={form.amount} onChange={value => onFieldChange('amount', value)} disabled={isSubmitting} />
    </div>
    {recurring && <div className="party-form__field">
      <PartyField id="recurrenceCount" label="Numero ricorrenze / rate" type="number" min="1" max="1000" step="1"
        value={form.recurrenceCount} placeholder="Senza limite" disabled={isSubmitting}
        onChange={value => onFieldChange('recurrenceCount', value)} />
      <p className="party-form__help">Numero totale di rate, inclusa la prima. Lascia vuoto per una spesa senza termine. L'importo indicato si applica a ciascuna rata.</p>
    </div>}
    {enableCustomFields && <ClientCustomFieldsSection formKey={expenseFormSchema.id} values={form.customFields || {}}
      onChange={fields => onFieldChange('customFields', fields)} api={EXPENSE_CUSTOM_FIELDS_API} />}
    {renderActions && <FormFooterAction><div className="flex gap-3 justify-end">
      <CreateFormCancelButton onClick={onCancel} disabled={isSubmitting} />
      <CreateFormSubmitButton form="expense-form" saving={isSubmitting}>{submitLabel}</CreateFormSubmitButton>
    </div></FormFooterAction>}
  </form>;
}
